import { render, staticRenderFns } from "./ShadowEdges.vue?vue&type=template&id=266b046c"
import script from "./ShadowEdges.vue?vue&type=script&lang=js"
export * from "./ShadowEdges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports